import { useEffect, useRef, useState } from 'react';
import { isInBrowser } from '@tronweb3/tronwallet-abstract-adapter';
export function useLocalStorage(key, defaultState) {
    const [state, setState] = useState(() => {
        try {
            const value = localStorage.getItem(key);
            if (value)
                return JSON.parse(value);
        }
        catch (error) {
            if (isInBrowser()) {
                console.error(error);
            }
        }
        return defaultState;
    });
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        try {
            if (state === null) {
                localStorage.removeItem(key);
            }
            else {
                localStorage.setItem(key, JSON.stringify(state));
            }
        }
        catch (error) {
            if (isInBrowser()) {
                console.error(error);
            }
        }
    }, [state, key]);
    return [state, setState];
}
//# sourceMappingURL=useLocalStorage.js.map